import { render, staticRenderFns } from "./LoginStrategyCredentials.vue?vue&type=template&id=2564ef37&"
import script from "./LoginStrategyCredentials.vue?vue&type=script&lang=js&"
export * from "./LoginStrategyCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports